<template lang='pug'>
v-dialog(
	:model-value='show'
	@update:model-value='!$event ? emit("clicked", "cancel") : null'
	width="auto"
	eager
	location="top"
	scrim="false"
	:scrollable="true"
	max-height="90%"
)
	.tw-white-card(class="emd:tw-p-1")
		.tw-text-lg.tw-mb-8(class="emd:tw-mb-3") {{ title || $t('dialogs.movement_details.operation_summary', 'Riepilogo Operazione') }}
		.tw-mb-8
			div.tw-text-center.tw-p-8.tw-font-bold.tw-underline(v-if="postSale.movementDetails.isFree") {{$t('dialogs.movement_details.free', 'Operazione Gratuita !')}}
			movement-detail(v-else-if="postSale.movementDetails")

			div(v-if='postSale.movementDetails.isRefund && !canRefund').tw-flex.tw-flex-col.tw-items-center.tw-border-t.tw-border-b.tw-py-5.tw-italic.tw-text-red-500.tw-mt-3
				v-icon.tw-text-4xl(icon="mdi mdi-alert" color='warning')
				p.tw-font-bold {{$t('dialogs.warning', 'Attenzione')}} !
				p(class="emd:tw-text-center") {{$t('dialogs.movement_details.cash', 'Acquisto effettuato in contanti, per richiedere il rimborso recarsi negli uffici preposti.')}}
			//p(v-else-if='postSale.movementDetails.isFree && postSale.operationIsAvailable') {{$t('dialogs.movement_details.free', 'Operazione Gratuita !')}}
			p(v-else-if='!postSale.movementDetails.isFree && !postSale.operationIsAvailable') {{$t('postsale.commons.is_not_possible_for_a_r', "Non è possibile effettuare questa operazione per entrambe i viaggi A/R assieme. Se possibile effettuare l'operazione singolarmente per l'andata ed il ritorno, oppure rivolgersi a Trenitalia.")}}

		.tw-px-2.tw-py-2.tw-flex.tw-items-center.tw-justify-between.tw-w-full.tw-gap-8
			v-btn(@click='emit("clicked", "cancel")' variant="outlined") {{$t('common.cancel', 'Annulla')}}
			v-btn(color='primary-darken-1' v-if="!postSale.movementDetails.isRefund || canRefund" @click="emit('clicked', 'movementAccepted')") {{ confirmText }}
</template>
	
<script setup>
import MovementDetail from "@/postsale/common-components/movement-detail.vue";
import {usePostSaleStore} from "@/stores/post-sale";
import { computed } from "vue";
import {get as _get} from 'lodash-es';
import {useI18n} from "vue-i18n";
import {useDialogManagerStore} from "@/stores/dialog-manager";

const i18n = useI18n();
const postSale = usePostSaleStore();
const emit = defineEmits(['clicked']);
const props = defineProps({
	title: {
		type: String,
		default: null
	}
});
const confirmText = computed(() => {
	if(!postSale.movementDetails.isFree && !postSale.movementDetails.isRefund) return i18n.t('dialogs.movement_details.proceed', 'Procedi al pagamento');
	if(!postSale.movementDetails.isFree && postSale.movementDetails.isRefund) return i18n.t('common.confirm', 'Conferma'); // how request the refund
	if(postSale.movementDetails.isFree) return i18n.t('common.confirm_change', 'Conferma la modifica'); // how request the refund
	return i18n.t('common.confirm', 'Conferma');
});
const canRefund = computed(() => {
	if ('true' == import.meta.env.VITE_POSTSALE_ALSO_FINALIZE_CASH_PAYMENTS) return true;
	return _get(postSale.reopenedTravel, 'can_direct_refund', false);
});
const show = computed(() => {
	if('true' == import.meta.env.VITE_ALWAYS_ADDTOPOSTSALECART) return true;
	return useDialogManagerStore().dialogConfigs.length <= 0 ? false : true;
})
</script>